import { __assign } from "tslib";
var BIService = /** @class */ (function () {
    function BIService(_a) {
        var _this = this;
        var siteStore = _a.siteStore, origin = _a.origin;
        this.removeItem = function (cart, product) {
            _this.siteStore.biLogger.removedProductFromCartSf(__assign(__assign({}, _this.baseParams), { cartId: cart.cartId, itemsCount: cart.items.length, productId: product.id, productType: product.productType, storeId: cart.storeId }));
        };
        this.applyCoupon = function (cart, couponCode, isMember) {
            _this.siteStore.biLogger.couponAppliedSf(__assign(__assign({}, _this.baseParams), { storeId: cart.storeId, cartId: cart.cartId, couponCode: couponCode,
                isMember: isMember }));
        };
        this.removeCoupon = function (cart, isMember) {
            _this.siteStore.biLogger.removeACouponSf(__assign(__assign({}, _this.baseParams), { storeId: cart.storeId, cartId: cart.cartId, couponId: cart.appliedCoupon.couponId, couponCode: cart.appliedCoupon.code, isMember: isMember }));
        };
        this.updateItemQuantity = function (cart, productId) {
            _this.siteStore.biLogger.updatedCartItemQuantitySf(__assign(__assign({}, _this.baseParams), { productId: productId, itemsCount: cart.items.length, storeId: cart.storeId }));
        };
        this.updateBuyerNote = function (cart, hasNote) {
            var biParams = __assign({ storeId: cart.storeId, cartId: cart.cartId }, _this.baseParams);
            hasNote
                ? _this.siteStore.biLogger.saveNoteToSellerSf(__assign(__assign({}, biParams), { is_empty: false }))
                : _this.siteStore.biLogger.deleteNoteToSellerSf(biParams);
        };
        this.siteStore = siteStore;
        this.origin = origin;
    }
    Object.defineProperty(BIService.prototype, "baseParams", {
        get: function () {
            return {
                origin: this.origin,
            };
        },
        enumerable: false,
        configurable: true
    });
    return BIService;
}());
export { BIService };
//# sourceMappingURL=BIService.js.map